import { IDropdownOption } from 'models/shared.models'
import {
  Accountant,
  RawAccountant,
  TManagementTabs,
} from 'models/management.models'
import { EXPIRED, WARNING, VALID } from '../../../constants'
import { MANAGEMENT_TABS } from 'lib/enums/management.enums'
import { ISydTab } from 'components/Shared/SydTabs/SydTabs'
import { ComponentType } from 'react'
import ManagementWorkspacesContainer from 'containers/Management/ManagementWorkspaces/ManagementWorkspacesContainer/ManagementWorkspacesContainer'
import ManagementAccountantsContainer from 'containers/Management/ManagementAccountants/ManagementAccountantsContainer/ManagementAccountantsContainer'

export const managementTabLabels: Record<TManagementTabs, string> = {
  [MANAGEMENT_TABS.WORKSPACES]: 'Espacios de Trabajo',
  [MANAGEMENT_TABS.ACCOUNTANTS]: 'Contadores',
} as const

export const managementTabs: Readonly<ISydTab[]> = [
  {
    id: 'management-tab-1',
    label: managementTabLabels[MANAGEMENT_TABS.WORKSPACES],
  },
  {
    id: 'management-tab-2',
    label: managementTabLabels[MANAGEMENT_TABS.ACCOUNTANTS],
  },
] as const

export const workspaceStatuses: IDropdownOption[] = [
  {
    id: 'workspace-status-1',
    label: 'Activo',
    value: '1',
  },
  {
    id: 'workspace-status-2',
    label: 'Inactivo',
    value: '2',
  },
  {
    id: 'workspace-status-3',
    label: 'Pendiente',
    value: '3',
  },
  {
    id: 'workspace-status-4',
    label: 'Suspendido Moroso',
    value: '4',
  },
  {
    id: 'workspace-status-5',
    label: 'Suspendido no contesta',
    value: '5',
  },
]

export const managementTabComponents: Record<TManagementTabs, ComponentType> = {
  [MANAGEMENT_TABS.WORKSPACES]: ManagementWorkspacesContainer,
  [MANAGEMENT_TABS.ACCOUNTANTS]: ManagementAccountantsContainer,
}

export const daysToExpire = (date: Date) => {
  const currentDate = new Date()
  const oneMonthFromNow = new Date()
  oneMonthFromNow.setMonth(currentDate.getMonth() + 1)

  if (date <= currentDate) {
    return EXPIRED
  } else if (date <= oneMonthFromNow) {
    return WARNING
  } else {
    return VALID
  }
}

export const normalizeAccountants = (
  accountants: RawAccountant[]
): Accountant[] => {
  return accountants.map(accountant => ({
    ...accountant,
    id: accountant.idUser,
  }))
}
